import React from "react";

import { ExpandMore } from "@mui/icons-material";

export const IgIconComponent = (props: any) => {
  return (
    <ExpandMore
      fontSize={"small"}
      className={props.className}
      {...props}
      sx={{
        color: props.color ?? "#000",
        right: "12px",
        position: "absolute",
        userSelect: "none",
        pointerEvents: "none",
      }}
    />
  );
};
